import {Component, forwardRef, OnInit} from '@angular/core';
import {AbstractControl, ControlValueAccessor, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {LienTache, TypeLien} from '../../../../models/taches/gestion-taches.model';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-edit-liens-taches',
  templateUrl: './edit-liens-taches.component.html',
  styleUrls: ['./edit-liens-taches.component.scss' ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditLiensTachesComponent),
      multi: true,
    },
  ],
})
export class EditLiensTachesComponent implements OnInit, ControlValueAccessor {

  subs: Subscription[] = [];
  form: UntypedFormGroup = new UntypedFormGroup({
    personnes: new UntypedFormControl(),
    formateurs: new UntypedFormControl(),
    entreprises: new UntypedFormControl(),
    sessions: new UntypedFormControl(),
    personnels: new UntypedFormControl(),
  });
  TypeLien = TypeLien;
  visibleSelectors = [];

  public undeletablePersonneIds: number[] = [];
  public undeletableFormateurIds: number[] = [];
  public undeletableEntrepriseIds: number[] = [];
  public undeletableSessionIds: number[] = [];
  public undeletablePersonnelIds: number[] = [];

  get personnesControl(): UntypedFormControl {
    return this.form.get('personnes') as UntypedFormControl;
  }

  get formateurControl(): UntypedFormControl {
    return this.form.get('formateurs') as UntypedFormControl;
  }

  get entreprisesControl(): UntypedFormControl {
    return this.form.get('entreprises') as UntypedFormControl;
  }

  get sessionsControl(): UntypedFormControl {
    return this.form.get('sessions') as UntypedFormControl;
  }

  get personnelsControl(): UntypedFormControl {
    return this.form.get('personnels') as UntypedFormControl;
  }

  choixLienVisible = false;
  private onchange = any => {}
  registerOnChange(fn: any): void {
    this.onchange = fn;
  }

  private concatLienFromAllFormControls() {
    return [...this.personnesControl.value, ...this.formateurControl.value, ...this.entreprisesControl.value, ...this.sessionsControl.value, ...this.personnelsControl.value]
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: LienTache[]): void {

    if (obj != null) {
      const personneLiens: LienTache[] =  obj.filter(lien => lien.typeLien == TypeLien.personne);
      const formateurLiens: LienTache[] = obj.filter(lien => lien.typeLien == TypeLien.formateur);
      const entrepriseLiens: LienTache[] = obj.filter(lien => lien.typeLien == TypeLien.entreprise);
      const sessionLiens: LienTache[] = obj.filter(lien => lien.typeLien == TypeLien.session);
      const personnelLiens: LienTache[] = obj.filter(lien => lien.typeLien == TypeLien.personnel);

      if (personneLiens.length > 0) {
        this.showSelectorForType(TypeLien.personne);
        this.undeletablePersonneIds = personneLiens.filter(l => l.isSuppressionDisabled).map(l => l.idLien);
      }
      if (formateurLiens.length > 0) {
        this.showSelectorForType(TypeLien.formateur);
        this.undeletableFormateurIds = formateurLiens.filter(l => l.isSuppressionDisabled).map(l => l.idLien);
      }
      if (entrepriseLiens.length > 0) {
        this.showSelectorForType(TypeLien.entreprise);
        this.undeletableEntrepriseIds = entrepriseLiens.filter(l => l.isSuppressionDisabled).map(l => l.idLien);
      }
      if (sessionLiens.length > 0) {
        this.showSelectorForType(TypeLien.session);
        this.undeletableSessionIds = sessionLiens.filter(l => l.isSuppressionDisabled).map(l => l.idLien);
      }
      if (personnelLiens.length > 0) {
        this.showSelectorForType(TypeLien.personnel);
        this.undeletablePersonnelIds = personnelLiens.filter(l => l.isSuppressionDisabled).map(l => l.idLien);
      }
      this.form.reset({
        personnes: personneLiens,
        formateurs: formateurLiens,
        entreprises: entrepriseLiens,
        sessions: sessionLiens,
        personnels: personnelLiens,
      });
    }
  }

  ngOnInit(): void {
    ['personnes', 'formateurs', 'entreprises','sessions', 'personnels'].forEach(type => {
      const formcontrol: AbstractControl = this.form.get(type);
      this.subs.push(formcontrol.valueChanges.subscribe(() => {
        if (formcontrol.dirty) {
          const result = this.concatLienFromAllFormControls();
          this.onchange(result);
        }
      }))
    })

  }

  showSelectorForType(type: TypeLien) {
    if (this.visibleSelectors.indexOf(type) < 0) {
      this.choixLienVisible = false;
      this.visibleSelectors.push(type);
    }
  }


  isSelectorVisible(type: TypeLien) {
    return this.visibleSelectors.indexOf(type)>=0;
  }
}
